import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from 'react';
// Create a context for the PharaohSwap instance
const PharaohServiceContext = createContext(null);
export const PharaohServiceProvider = ({ children, pharaohService }) => {
    return _jsx(PharaohServiceContext.Provider, { value: pharaohService, children: children });
};
export const usePharaohService = () => {
    const context = useContext(PharaohServiceContext);
    if (!context) {
        throw new Error('usePharaohService must be used within a PharaohServiceProvider');
    }
    return context;
};
//# sourceMappingURL=pharaoh-service.js.map